<div class="w-full itm-page-layout">
    <div class="w-full">
        <div class="flex flex-row">
            <div class="basis-11/12 text-lg font-bold uppercase">{{this.actionData()?.actionTitle}}</div>
            <div class="basis-1/12 text-right">
                <span class="e-icons e-medium e-close cursor-pointer" (click)="closeClick()"></span>
            </div>
        </div>
        <div class="my-2 border border-solid bg-gray-500"></div>
        <div class="flex flex-row">
            @if(openingAudit()==true){
                <itm-audit-detail class="w-full"></itm-audit-detail>
            }
            @else if(this.actionData() != undefined){
                @if(this.actionData().actionTypeId == ActionType.Alert){
                    <alert-sidebar #sidebar (fireReminderHourEvent)="onRemindHourClick($event)"
                        (fireDoNotEscalateEvent)="onDoNotEscalateClick($event)"
                        (fireResolveEvent)="onResolveClick($event)"
                        [actionData]="actionData()">
                    </alert-sidebar>
                }
                @else if(this.actionData().actionTypeId == ActionType.PurchaseRequisition){
                    @if(actionData()?.actionSubTypeId== ActionPRSubType.PRRequest
                        || actionData()?.actionSubTypeId== ActionPRSubType.SubHirePRRequest){
                        <purchase-requisition-sidebar #sidebar (fireRejectEvent)="onRejectClick($event)"
                            (fireApproveEvent)="onApproveClick($event)" (fireRequestInfoEvent)="onRequestInfoClick($event)"
                            [actionData]="actionDataSig()" [inProgress]="inProgress()">
                        </purchase-requisition-sidebar>
                    }
                    @else if(actionData()?.actionSubTypeId== ActionPRSubType.PRRequestSupplier){
                        <supplier-sidebar #sidebar (fireRejectEvent)="onRejectClick($event)"
                            (fireApproveEvent)="onApproveClick($event)"
                            [actionData]="actionData()">
                        </supplier-sidebar>
                    }
                }
                @else if(this.actionData().actionTypeId == ActionType.ApplyEasy){
                    <applyeasy-sidebar #sidebar
                        (fireResolveWithCustomerEvent)="onResolveWithCustomerClick()"
                        [actionData]="actionData()">
                    </applyeasy-sidebar>
                }
                @else if(this.actionData().actionTypeId == ActionType.PurchaseOrder){
                    @if(actionData()?.actionSubTypeId== ActionPOSubType.PORequest){
                        <purchase-requisition-sidebar #sidebar (fireRejectEvent)="onRejectClick($event)"
                            (fireApproveEvent)="onApproveClick($event)" (fireRequestInfoEvent)="onRequestInfoClick($event)"
                            [actionData]="actionDataSig()" [inProgress]="inProgress()">
                        </purchase-requisition-sidebar>
                    }
                }
            }
        </div>
    </div>
</div>
